var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.402,
    height: 23.203,
    viewBox: "0 0 17.402 23.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file",
    "data-name": "Icon awesome-file",
    d: "M10.151,6.163V0H1.088A1.085,1.085,0,0,0,0,1.088V22.115A1.085,1.085,0,0,0,1.088,23.2H16.315A1.085,1.085,0,0,0,17.4,22.115V7.251H11.239A1.091,1.091,0,0,1,10.151,6.163ZM17.4,5.524V5.8H11.6V0h.276a1.087,1.087,0,0,1,.77.317l4.437,4.441A1.084,1.084,0,0,1,17.4,5.524Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.2313dd26df313ea8851d7322b1365474.svg";
export { ForwardRef as ReactComponent };